module.exports = __webpack_public_path__ + "static/media/6531.6a944851.jpg";